// Make material-ui aware of the custom helix colors.
declare module '@mui/material/styles' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface Palette extends ColorPalette {}

  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface PaletteOptions extends ColorPalette {}
}

type ColorPalette = typeof materialUIColorPalette;

export const materialUIColorPalette = {
  /* @FIXME These should come from @projectaussie/component-library eventually. Until then, we have to define them ourselves. */
  helix: {
    // Helix - neutrals
    white: '#ffffff',

    // Helix - colors
    blueDark: '#0073a8',
    greyDark: '#61656B',
    greyLight: '#DDDDDD',
    background: '#F7F7F7',
    greyLightest: '#F0F0F0',
    yellowLight: '#FFEEB6',
  },
  // Hybrid Health Result Severity
  healthResultSeverity: {
    clear: '#2E7D32',
    notable: '#0288D1',
    increasedRisk: '#C84346',
    noResult: '#F0F0F0',
  },
};
